var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ticket-queue"},[_c('div',{staticClass:"queue-header"},[_c('h5',{staticClass:"mb-0"},[_vm._v("Очередь")])]),_c('div',{staticClass:"queue-content"})])
}]

export { render, staticRenderFns }